import api from "@/api";
import moment from "moment";
export default class InspectionSheet {
  constructor(rawdata = {}) {
    if (rawdata) {
      for (let prop in rawdata) {
        this[prop] = rawdata[prop];
      }
    }

    this.id = rawdata.id ? rawdata.id : 0;
    this.e_signature = rawdata.e_signature ? rawdata.e_signature : "";
    this.certificates = rawdata.certificates ? rawdata.certificates : [];
    this.date_received = rawdata.date_received ? rawdata.date_received : "";
    this.time_received = rawdata.time_received ? rawdata.time_received : "";
    this.supplier_id = rawdata.supplier_id ? rawdata.supplier_id : "";
    this.supplier_name = rawdata.supplier_name ? rawdata.supplier_name : "";
    this.po_id = rawdata.po_id ? rawdata.po_id : "";
    this.po_no_id = rawdata.po_no_id ? rawdata.po_no_id : "";
    this.po_no = rawdata.po_no ? rawdata.po_no : "";
    this.delivery_note_no = rawdata.delivery_note_no
      ? rawdata.delivery_note_no
      : "";
    this.invoice_no = rawdata.invoice_no ? rawdata.invoice_no : "";
    this.freight_forwarder = rawdata.freight_forwarder
      ? rawdata.freight_forwarder
      : "";
    this.batch_no = rawdata.batch_no ? rawdata.batch_no : "";
    this.match_po = rawdata.match_po ? rawdata.match_po : 1;
    this.match_part_no = rawdata.match_part_no ? rawdata.match_part_no : 1;
    this.match_part_description = rawdata.match_part_description
      ? rawdata.match_part_description
      : 1;
    this.hidden_damage = rawdata.hidden_damage ? rawdata.hidden_damage : 0;
    this.visible_damages = rawdata.visible_damages
      ? rawdata.visible_damages
      : 0;
    this.adequate_packaging = rawdata.adequate_packaging
      ? rawdata.adequate_packaging
      : 1;
    this.item_damage = rawdata.item_damage ? rawdata.item_damage : 0;
    this.apparent_leakage = rawdata.apparent_leakage
      ? rawdata.apparent_leakage
      : 0;
    this.quantity_complete = rawdata.quantity_complete
      ? rawdata.quantity_complete
      : 1;
    this.remarks = rawdata.remarks ? rawdata.remarks : "";
    this.received_by = rawdata.received_by ? rawdata.received_by : "";
    this.status = rawdata.status ? true : false;
    this.batch_id = rawdata.batch_id ? rawdata.batch_id : 0;
    this.requested_by = rawdata.requested_by ? rawdata.requested_by : "";
    this.requested_by_position = rawdata.requested_by_position
      ? rawdata.requested_by_position
      : "";

    if ("fields" in rawdata) {
      this.supplier_name = rawdata.fields.supplier_name;
      this.certificates = [...rawdata.fields.certificates];
      this.match_po = rawdata.fields.match_po;
      this.match_part_no = rawdata.fields.match_part_no;
      this.match_part_description = rawdata.fields.match_part_description;
      this.hidden_damage = rawdata.fields.hidden_damage;
      this.visible_damages = rawdata.fields.visible_damages;
      this.adequate_packaging = rawdata.fields.adequate_packaging;
      this.item_damage = rawdata.fields.item_damage;
      this.apparent_leakage = rawdata.fields.apparent_leakage;
      this.quantity_complete = rawdata.fields.quantity_complete;
      this.remarks = rawdata.fields.remarks;
      this.delivery_note_no = rawdata.fields.delivery_note_no;
      this.invoice_no = rawdata.fields.invoice_no;
      this.freight_forwarder = rawdata.fields.freight_forwarder;
      this.date_received = moment(rawdata.fields.date_received).format(
        "YYYY-MM-DD"
      );
      this.time_received = moment(
        `${moment().format("YYYY-MM-DD")} ${rawdata.fields.time_received}`
      ).format("LLLL");
      this.po_no = rawdata.fields.po_no;
      this.po_id = rawdata.po_no_id;
      this.requested_by = rawdata.fields.requested_by;
      this.requested_by_position = rawdata.fields.requested_by_position;
    }
  }

  static async create(payload) {
    const result = await api.post(`/api/v1/inventory/receiving/`, payload);
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async update(payload) {
    const result = await api.post(
      `/api/v1/inventory/update_receiving/${payload.id}/`,
      payload
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async fetch(id) {
    const result = await api.get(`/api/v1/inventory/view_materials/?id=${id}`);
    if (result && result.status == 200) {
      let data = result.data.data[0];
      if (data === undefined) {
        return null;
      }
      return data;
    }

    return null;
  }

  static async postDocument(payload) {
    const result = await api.post(
      `/api/v1/inventory/document_upload/`,
      payload
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async getDocuments(inspection_id) {
    const result = await api.get(
      `/api/v1/inventory/document_list/?inspection_id=${inspection_id}`
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async deleteDocument(doc_id) {
    const result = await api.get(
      `/api/v1/inventory/delete_document/${doc_id}/`
    );
    if (result && result.status == 200) return result.data.data;
    return null;
  }

  static rules() {
    return {
      date_received: [
        {
          required: true,
          message: "Date received is required.",
          trigger: "change"
        }
      ],
      time_received: [
        {
          required: true,
          message: "Time received is required.",
          trigger: "blur"
        }
      ],
      // supplier_name: [
      //   {
      //     required: true,
      //     message: "Supplier is required.",
      //     trigger: "blur"
      //   }
      // ],
      po_id: [
        {
          required: true,
          message: "Purchase Order is required.",
          trigger: "blur"
        }
      ],
      delivery_note_no: [
        {
          required: true,
          message: "Delivery Note number is required.",
          trigger: "blur"
        }
      ],
      invoice_no: [
        {
          required: true,
          message: "Invoice number is required.",
          trigger: "blur"
        }
      ],
      freight_forwarder: [
        {
          required: true,
          message: "Freight Fowarder is required.",
          trigger: "blur"
        }
      ],
      // batch_no: [
      //   {
      //     required: true,
      //     message: "Batch number is required.",
      //     trigger: "blur"
      //   }
      // ],
      requested_by: [
        {
          required: true,
          message: "Requested by is required.",
          trigger: "blur"
        }
      ],
      requested_by_position: [
        {
          required: true,
          message: "Position is required.",
          trigger: "blur"
        }
      ]
      // e_signature: [{ required: true, message: "E-Signature is required." }]
    };
  }
}
